<template>
  <div>
    <MarketSettingTask
      :isMainLoading="isMainLoading"
      :marketId="marketId"
      @onInitSettingTask="onInitSettingTask"
    />
  </div>
</template>

<script>
import MarketSettingTask from "../../components/MarketSettingTask.vue";
export default {
  components: {
    MarketSettingTask
  },
  props: {
    isMainLoading: Boolean,
    marketId: String
  },
  methods: {
    onInitSettingTask(value) {
      this.$emit("onInitSettingTask", "billing_setting");
    }
  }
};
</script>
